import { useCallback, useEffect, useRef } from 'react'
import Styles from './PropertyForm.module.scss'
import { Field, useField } from 'formik'
import { Property } from 'api/clients/PropertyClient'
import cx from 'classnames'

interface Props {
  property?: Property
  isEdit: boolean
  isRename: boolean
  disabled?: boolean
  autoFocus?: boolean
}

const NameInput = ({ autoFocus, property, isEdit, disabled = false, isRename = false }: Props) => {
  const [field, meta, helpers] = useField({ name: 'name' })
  const { setError } = helpers
  const fieldInputRef = useRef<HTMLInputElement>()

  const validateName = useCallback(
    (name: string) => {
      if (disabled) {
        return
      }
      if (!name) {
        return setError('Property name is required')
      }

      if (isEdit && property?.name === name) return
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isEdit, property?.name],
  )

  useEffect(() => {
    if (!meta.error) validateName(field.value)
  }, [meta.error, field.value, validateName])

  // Highlight input when creating a new property or renaming
  useEffect(() => {
    if (!isEdit || isRename) fieldInputRef.current?.select()
  }, [isEdit, isRename])

  return (
    <div className={Styles.nameInputWrapper}>
      <div
        className={cx(Styles.formInput, Styles.formText, {
          [Styles.inputError]: meta.error,
          [Styles.disabledInput]: disabled,
        })}
      >
        <Field
          innerRef={fieldInputRef}
          type="text"
          autoComplete="off"
          name="name"
          placeholder="Name"
          id="name"
          disabled={disabled}
          autoFocus={autoFocus}
        />
      </div>
      {meta.error && <div className={Styles.formError}>{meta.error}</div>}
    </div>
  )
}

export default NameInput
